import React, { useEffect, useState } from "react";
import {Table, Row, Col, Card, CardBody, Modal, CardTitle, ModalHeader, ModalBody, Label, Button} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import moment from "moment";
import "flatpickr/dist/themes/material_blue.css";
import Select from "react-select";
import { Link } from "react-router-dom";
const Tarifications = () => {
  document.title = "AMAVIE | Gestion de la tarification";
  
  const [tarifications, setTarifications]= useState([])
  const [tranches, setTranches]= useState([{label: "Toutes les tranche", value: 0}])
  const [zones, setZones]= useState([{label: "Toutes les zones", value: 0}])
  const [periodicities, setPeriodicities]= useState([{label: "Toutes les périodes", value: 0}])
  const [tranche, setTranche]= useState(null)
  const [zone, setZone]= useState(null)
  const [itemId, setItemId]= useState(null)
  const [periodicity, setPeriodicity]= useState(null)
  const [trancheUpdate, setTrancheUpdate]= useState(null)
  const [zoneUpdate, setZoneUpdate]= useState(null)
  const [periodicityUpdate, setPeriodicityUpdate]= useState(null)
  const [tarif, setTarif]= useState(0)
  const [agvAccess, setAgvAccess]= useState(0)
  const [errorMsg, setErrorMsg]= useState(null)
  const [successMsg, setSuccessMsg]= useState(null)
  const [modal_tarification, setmodal_tarification]= useState(false)
  
  const checkInput = () => {
    if (!itemId) { setErrorMsg('Identifiant non sélectionné'); return false;}
    if (!zoneUpdate) { setErrorMsg('Veuillez sélectionner la zone'); return false;}
    if (!trancheUpdate) { setErrorMsg('Veuillez sélectionner la tranche d\'age svp'); return false;}
    if (!periodicityUpdate) { setErrorMsg('Veuillez sélectionner la période svp'); return false;}
    if (tarif<10000) { setErrorMsg('Le montant ne peut être inféreur à 10000FCFA'); return false;}
      setErrorMsg("")
      return true;
  };
  const removeBodyCss = () => { document.body.classList.add("no_padding"); };
  const tog_tarification = () => { setmodal_tarification(!modal_tarification); removeBodyCss(); };

  const loadZones=()=> {
      fetch(`${url.BACKEND_URL}/zones`, { method: 'GET', headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => { 
        console.log(responseJson.data)
        if (responseJson.status==200) {
          setZones([...zones, ...responseJson.data.map(item=>({label: item.name, value: item.id}))])
      } else { setZones([]); }
      }) .catch((error) => { });
    };

  const loadTranches=()=> {
        fetch(`${url.BACKEND_URL}/tranches`, { method: 'GET', headers: { Accept: 'application/json'} })
        .then((response) => response.json())
        .then((responseJson) => {           
          if (responseJson.status==200) {
            setTranches([...tranches, ...responseJson.data.map(item=>({label: `${item.min} à ${item.max} ans`, value: item.id}))])
        } else { setTranches([]); }
        }) .catch((error) => { });
      };

  const loadPeriodicities=()=> {
        fetch(`${url.BACKEND_URL}/periodicities`, { method: 'GET', headers: { Accept: 'application/json'} })
        .then((response) => response.json())
        .then((responseJson) => {           
          if (responseJson.status==200) {
            setPeriodicities([...periodicities, ...responseJson.data.map(item=>({label: `${item.min} à ${item.max} jours`, value: item.id}))])
        } else { setPeriodicities([]); }
        }) .catch((error) => { });
      };

  const loadTarification=(tranche, zone, periodicity)=> {
      fetch(`${url.BACKEND_URL}/tarifications?tranche=${tranche ? tranche.value: 0}&zone=${zone ? zone.value: 0}&periodicity=${periodicity ? periodicity.value: 0}`, {
        method: 'GET', headers: { Accept: 'application/json'} })
      .then((response) => response.json())
      .then((responseJson) => { 
        if (responseJson.status==200) { setTarifications(responseJson.data) }
        else { setTarifications([]) }
      }) .catch((error) => {  });
    };

  const updateTarification= ()=>{
    if (checkInput()) {
      const jsonData= {id: itemId, tranche: {id: trancheUpdate.value}, zone: {id: zoneUpdate.value}, periodicity: {id: periodicityUpdate.value}, tarif: tarif, agv_access: agvAccess};
      console.log(JSON.stringify(jsonData));
      
      fetch(`${url.BACKEND_URL}/tarifications`, {
          method: 'PUT', 
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, 
          body: JSON.stringify(jsonData) })
        .then((response) => response.json())
        .then((responseJson) => { 
          console.log(responseJson);
          if (responseJson.status==200) {
            setTarifications(prevTarifications => 
              prevTarifications.map(trf => 
                trf.id === itemId ? { ...trf, tarif: tarif, agv_access: agvAccess, zone: {id: zoneUpdate.value, name: zoneUpdate.label} } : trf )
            );
            setSuccessMsg(responseJson.message)
            setTimeout(() => {tog_tarification(); setSuccessMsg(""); }, 400);
        } else { setErrorMsg(responseJson.message); }
        }) .catch((error) => { setErrorMsg(error); });
    }
  }
  useEffect(()=>{ loadTarification(tranche, zone, periodicity), loadZones(), loadTranches(), loadPeriodicities() }, [])
  return (
    <React.Fragment>
      <div className="page-content">
        <Modal isOpen={modal_tarification} toggle={tog_tarification} size="lg">
            <ModalHeader className="mt-0" toggle={tog_tarification}>Modification de la tarification</ModalHeader>
            <ModalBody>
              <form>
                <Row>
                  <Col lg="6">
                    <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                      <Label>Zone</Label>
                      <Select
                        value={zoneUpdate} 
                        isMulti={false}
                        onChange={(selected) => { setZoneUpdate(selected); }}
                        options={zones} 
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>

                  <Col lg="6">
                    <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                      <Label>Tranche d'age</Label>
                      <Select
                        value={trancheUpdate} 
                        isMulti={false}
                        onChange={(selected) => { setTrancheUpdate(selected); }}
                        options={tranches} 
                        classNamePrefix="select2-selection" 
                        isLoading={false}
                      />
                    </div>
                  </Col>
                  
                  <Col lg={4}>
                    <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                      <Label>Période</Label>
                      <Select
                        value={periodicityUpdate} 
                        isMulti={false}
                        onChange={(selected) => { setPeriodicityUpdate(selected); }}
                        options={periodicities} 
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label>Tarif</Label>
                      <input className="form-control" placeholder="Montant" value={tarif} onChange={(event)=>{ setTarif(event.target.value); }} type="number" min={10000} id="example-datetime-local-input"/>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label>AGV ACCESS</Label>
                      <input className="form-control" placeholder="Montant" value={agvAccess} onChange={(event)=>{ setAgvAccess(event.target.value); }} type="number" min={10000} id="example-datetime-local-input"/>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ marginTop: 20}}>
                    <strong className="text-danger">{errorMsg}</strong>
                    <strong className="text-success">{successMsg}</strong>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ marginTop: 20}}>
                    <Button color="primary" style={{ fontSize: 20  }} className="form-control btn btn-primary waves-effect waves-light" onClick={()=>updateTarification()}>Modifier la tarification</Button>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>
        <div className="container-fluid">
          <Breadcrumbs maintitle="AMAVIE" title="Tarifications" />
          <Row>
            <CardTitle className="h4">Liste des tarifications</CardTitle>
            <Col md={3}>
              <div className="mb-3">
                <Label>Zone</Label>
                <Select
                  value={zone}
                  onChange={(event)=>{setZone(event)}}
                  options={zones}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="mb-3">
                <Label>Tranche</Label>
                <Select
                  value={tranche}
                  onChange={(event)=>{setTranche(event)}}
                  options={tranches}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="mb-3">
                <Label>Période</Label>
                <Select
                  value={periodicity}
                  onChange={(event)=>{setPeriodicity(event)}}
                  options={periodicities}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="mb-3">
                <Label style={{ visibility: "hidden" }}>--</Label>
                <Button color="primary" className="form-control btn btn-primary waves-effect waves-light" onClick={()=>loadTarification(tranche, zone, periodicity)}><i className="fas fa-search"></i> Rechercher</Button>
              </div>
            </Col>
             <Col xl={3}>
                <Label style={{ visibility: "hidden" }}>--</Label>
                <Link color="primary" onClick={()=>alert("OK")} className="form-control btn btn-warning waves-effect"><i className="fas fa-money-check-alt"></i> Ajouter une Tarification</Link>
              </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <div className="table-responsive">
                    <Table className="table mb-0" style={{fontSize: 16}}>
                      <thead className="table-light">
                        <tr>
                          <th>Zone</th>
                          <th>Période</th>
                          <th>Tranche d'age</th>
                          <th>Montant</th>
                          <th>AGV ACCESS</th>
                          <th>Modifier</th>
                          {/* <th>Détails</th> */}
                        </tr>
                      </thead>
                      <tbody>
                         {tarifications.map((item, key)=>(
                            <tr>
                              <td><span className="badge bg-success" style={{padding: 7}}>{item?.zone.name}</span></td>
                              <td>
                                <span className="badge bg-warning" style={{padding: 7}}>
                                  De {item?.periodicity?.min} {" "} à {item?.periodicity?.max} jours
                                </span>
                              </td>
                              <td>
                                <span className="badge bg-info" style={{padding: 7}}>
                                  De {item?.tranche?.min} {" "} à {item?.tranche?.max} an(s)
                                </span>
                              </td>
                              <td><span className="badge bg-primary" style={{padding: 7}}>{(item?.tarif).toLocaleString("fr-FR")} FCFA</span></td>
                              <td><span className="badge bg-primary" style={{padding: 7}}>{(item?.agv_access).toLocaleString("fr-FR")} FCFA</span></td>
                              <td><a className="fas fa-edit" onClick={()=>{setPeriodicityUpdate({label:`${item?.periodicity.min} à ${item?.periodicity.max} jours`, value: item?.periodicity.id}), setZoneUpdate({label:item?.zone?.name, value: item?.zone?.id}), setTrancheUpdate({label:`${item?.tranche?.min} à ${item?.tranche?.max}`, value: item?.tranche?.id}), setTarif(item?.tarif), setAgvAccess(item?.agv_access), setItemId(item?.id), tog_tarification()}}></a></td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Tarifications;
